<template>
  <div v-redirect-if-no-permission:REGISTERED_CAPTAINS>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreateConstraint' }">
        <v-btn v-if="this.$store.state.user.roles[0].name != 'Call center'" color="primary">{{ $t("drivers.constraints.newConstraint") }}</v-btn>
      </router-link>
    </v-layout>
    <data-table
      ref="constraintsDataTable"
      :url="api.ACTIONS.CONSTRAINTS"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      :formatter="formatters"
      perPage="100"
      :fields-hidden-main="['id', 'updated_at', 'created_at','strike_through']"
      :titles="titles"
      :actions-extra-main="actionsExtraMain"
      :disable-search="false"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Constraints",
  title() {
    return this.$t("drivers.constraints.title");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
        driver_on_off(value) {
          return `<span style="color: ${
            value == "Yes" ? "green" : "red"
          }">${value}</span>`;
        },
        customer_on_off(value) {
          return `<span style="color: ${
            value == "Yes" ? "green" : "red"
          }">${value}</span>`;
        },
        dashboard_on_off(value) {
          return `<span style="color: ${
            value == "Yes" ? "green" : "red"
          }">${value}</span>`;
        },
        strike_through_txt(value) {
          return `<span style="color: ${
            value == "Yes" ? "green" : "red"
          }">${value}</span>`;
        },
      },
      constraints: "",
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
    };
  },
  computed: {
    titles() {
      return {
        constraint_name: this.$t("drivers.constraints.constraintName"),
        Abbreviation: this.$t("drivers.constraints.abbreviation"),
        customer_app_message: this.$t("drivers.constraints.customerAppMessage"),
        driver_on_off: this.$t("drivers.constraints.canDriverEdit"),
        customer_on_off: this.$t("drivers.constraints.shownInCustomerApp"),
        dashboard_on_off: this.$t("drivers.constraints.shownInCustomerDashboard"),
        entity_type: this.$t("drivers.constraints.type"),
        strike_through_txt: this.$t("drivers.constraints.strikeThrough"),
      };
    },
    actionsExtraMain() {
      if (this.$store.state.user.roles[0].name == 'Call center') return {};  
      return {
        editConstraint: {
          title: this.$t("drivers.constraints.editConstraint"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditConstraint",
              params: { id: item.id },
            }),
        },
        deleteConstraint: {
          title: this.$t("drivers.constraints.deleteConstraint"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`dynamic_constraints/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("drivers.constraints.deletedSuccessfully"),
                  "green"
                );
                this.$refs.constraintsDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit("SHOW_TOAST", this.$t("drivers.constraints.somethingWentWrong"), "red");

                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
